import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import BonusCampaignsList from './BonusCampaignsList';
import BonusCampaignDetails from './BonusCampaignDetails';

const BonusCampaigns = () => (
  <Routes>
    <Route index element={<BonusCampaignsList />} />
    <Route path=":bonusId" element={<BonusCampaignDetails />} />
    <Route path="*" element={<Navigate to="." replace />} />
  </Routes>
);

export default BonusCampaigns;
